import { createFileRoute, useParams } from "@tanstack/react-router"
import { scheduleQueryKeys } from "toptaal-shared"
import { OrganizationCalendarWithModal } from "@/components/modals/calendar/OrganizationCalendarWithModal"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { fetchStudentSchedule } from "@/api/services/student"

export const Route = createFileRoute("/beheer/cursisten/$studentId/lessen/")({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "students"),
})

function RouteComponent() {
  const { studentId } = useParams({ from: "/beheer/cursisten/$studentId" })

  return (
    <OrganizationCalendarWithModal
      id={Number(studentId)}
      showStudentAttendance
      getQueryKey={scheduleQueryKeys.student}
      queryFn={({ id, startDate, endDate }) =>
        fetchStudentSchedule({ id, startDate, endDate })
      }
    />
  )
}
